/**
 * @format
 */

import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

export interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  large?: boolean;
}

const Divider: React.FC<Props> = (props) => {
  const style = [styles.divider, props.containerStyle];
  if (props.large) {
    style.push(styles.large);
  }
  return <View style={style} />;
};

const styles = StyleSheet.create({
  divider: {
    backgroundColor: '#f7f7f7',
    width: '100%',
    height: 10,
  },
  large: {
    height: 10,
  },
});

export default Divider;
